import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.855 27.946c1.545.176 3.017-.078 4.255-.753a6.496 6.496 0 0 0 1.504-1.15c.662-.666 1.013-1.061 1.38-1.564l.045-.052c.459-.53.637-.87.673-1.388.059-.81-.3-1.431-1.145-2.215-.498-.462-1.09-.853-1.811-1.206a31.721 31.721 0 0 0-.428-.21c-.528-.25-.93-.4-1.338-.49-.809-.18-1.53-.076-2.13.352-.238.168-.41.335-.71.677l-.067.077a5.853 5.853 0 0 1-.166.182c-.333.348-.647.596-.966.767-1.577.84-3.784.495-5.15-.807-.766-.805-1.236-2.014-1.208-3.151a4.417 4.417 0 0 1 .86-2.534c.146-.194.288-.35.676-.746l.199-.204c.509-.53.762-1.123.757-1.82-.004-.59-.13-1.034-.509-1.907l-.038-.087-.036-.085c-.329-.763-.6-1.265-.943-1.73-.53-.718-1.068-1.197-1.686-1.455a1.955 1.955 0 0 0-1.346-.076c-.346.109-.567.252-.975.608a5.686 5.686 0 0 1-.115.099c-1.466 1.121-2.335 2.094-2.861 3.28-.863 1.944-.741 4.257.266 6.751.861 2.13 2.294 4.185 4.129 5.947a18.927 18.927 0 0 0 3.408 2.788c1.83 1.178 3.682 1.898 5.476 2.102Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Call-Inbound-Filled_svg__a",
      width: 11,
      height: 11,
      x: 17,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M22.286 4.571v7.763L18.69 8.738a.571.571 0 1 0-.808.809l4.562 4.562a.57.57 0 0 0 .828-.002l4.56-4.56a.571.571 0 1 0-.808-.809l-3.595 3.596V4.571a.571.571 0 0 0-1.143 0Z"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Call-Inbound-Filled_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "#00B388", d: "M16 3h12v12H16z" }))
);
var SvgCallInboundFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallInboundFilled_default = SvgCallInboundFilled;

export { CallInboundFilled_default as default };
